// extracted by mini-css-extract-plugin
export default {"linksSection":"kO-z"};